import {
    ContactOrganizerButton,
    ContactOrganizerProps,
} from '@eventbrite/contact-organizer-button';
import React from 'react';
import './ContactOrganizerButtonListings.scss';

export const ContactOrganizerButtonListings: React.FC<ContactOrganizerProps> = (
    props,
) => {
    return (
        <ContactOrganizerButton
            {...props}
            className={`contact-organizer-listing-page`}
        />
    );
};
